import React, { useState, useEffect } from 'react';
import { pmndpAPI } from '../../../services/pmndp.api';
import { toast } from "react-toastify";
import PMNDPLoader from './PMNDPLoader';
import PMNDPModal from './PMNDPModal';
import { PMNDPFormField, PMNDPFormSection, PMNDPFormButtons } from './PMNDPForm';
import styles from './pmndp-enhanced.module.css';

const MachineManagement = ({ onClose, getMachines, editData }) => {
  const labels = {
    addMachine: "Add Machine",
    editMachine: "Edit Machine",
    machineDetails: "Machine Details:",
    machineName: "Machine Name",
    machineSrNo: "Machine Serial No",
    machineType: "Machine Type",
    machineStatus: "Machine Status",
    general: "General",
    hiv: "HIV",
    hcv: "HCV",
    hbv: "HBV",
    hivHcvHbv: "HIV/HCV/HBV",
    doublePositive: "Double Positive",
    functional: "Functional",
    nonFunctional: "Non Functional",
    condemn: "Condemn",
    wrongEntry: "Wrong Entry",
    save: "Save",
    cancel: "Cancel"
  };

  const [formData, setFormData] = useState({
    machine_name: '',
    sr_no: '',
    machine_type: '',
    machine_status: ''
  });
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    if (editData) {
      setFormData({
        machine_name: editData.machine_name || '',
        sr_no: editData.sr_no || '',
        machine_type: editData.machine_type || '',
        machine_status: editData.machine_status ? String(editData.machine_status) : ''
      });
    }
  }, [editData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const errors = {};
    if (!formData.machine_name) errors.machine_name = "Machine Name is required";
    if (!formData.sr_no) errors.sr_no = "Serial No is required";
    if (!formData.machine_type) errors.machine_type = "Machine Type is required";
    if (!formData.machine_status) errors.machine_status = "Machine Status is required";

    setFormErrors(errors);
    if (Object.keys(errors).length > 0) return;

    setLoading(true);
    try {
      const facilityId = JSON.parse(localStorage.getItem('loggedinUserdetails'))?.facilityTypeId;
      const payload = {
        id: editData?.id || null,
        ...formData,
        facility_id: facilityId
      };

      const resp = await pmndpAPI.createMachine(payload);
      if (resp?.success) {
        toast.success(editData ? 'Machine updated successfully!' : 'Machine created successfully!');
        if (getMachines) getMachines();
        setTimeout(onClose, 1200);
      } else {
        toast.error(resp?.msg || 'Failed to save machine');
      }
    } catch (error) {
      toast.error('Network error occurred');
    } finally {
      setLoading(false);
    }
  };

  const machineTypeOptions = [
    { value: 'General', label: labels.general },
    { value: 'HIV', label: labels.hiv },
    { value: 'HCV', label: labels.hcv },
    { value: 'HBV', label: labels.hbv },
    { value: 'HIV/HCV/HBV', label: labels.hivHcvHbv },
    { value: 'Double-Positive', label: labels.doublePositive }
  ];

  const machineStatusOptions = [
    { value: '1', label: labels.functional },
    { value: '2', label: labels.nonFunctional },
    { value: '3', label: labels.condemn },
    { value: '4', label: labels.wrongEntry }
  ];

  return (
    <>
      
      {loading && <PMNDPLoader type="modern" fullscreen={true} text={editData ? "Updating Machine..." : "Creating Machine..."} />}

      <PMNDPModal
        isOpen={true}
        onClose={onClose}
        title={editData ? labels.editMachine : labels.addMachine}
        icon="fa-cogs"
        size="large"
        footer={
          <PMNDPFormButtons
            onSave={handleSubmit}
            onCancel={onClose}
            saveText={editData ? "Update" : labels.save}
            cancelText={labels.cancel}
            isLoading={loading}
            disabled={Object.keys(formErrors).length > 0}
          />
        }
      >
        <form onSubmit={handleSubmit}>
          <PMNDPFormSection title={labels.machineDetails} icon="fa-info-circle">
            <PMNDPFormField
              label={labels.machineName}
              value={formData.machine_name}
              onChange={(e) => setFormData({...formData, machine_name: e.target.value})}
              error={formErrors.machine_name}
              placeholder="Enter machine name"
              required
            />
            
            <PMNDPFormField
              label={labels.machineSrNo}
              value={formData.sr_no}
              onChange={(e) => setFormData({...formData, sr_no: e.target.value})}
              error={formErrors.sr_no}
              placeholder="Enter serial number"
              required
            />
            
            <PMNDPFormField
              label={labels.machineType}
              type="select"
              value={formData.machine_type}
              onChange={(e) => setFormData({...formData, machine_type: e.target.value})}
              error={formErrors.machine_type}
              options={machineTypeOptions}
              placeholder="Select machine type"
              required
            />
            
            <PMNDPFormField
              label={labels.machineStatus}
              type="select"
              value={formData.machine_status}
              onChange={(e) => setFormData({...formData, machine_status: e.target.value})}
              error={formErrors.machine_status}
              options={machineStatusOptions}
              placeholder="Select machine status"
              required
            />
          </PMNDPFormSection>
        </form>
      </PMNDPModal>
    </>
  );
};

export default MachineManagement;
